import React from 'react';
import { Scissors, Hash, Maximize, Sliders, Type, Image, QrCode, HelpCircle } from 'lucide-react';
export type ToolType = 'cutline' | 'quantity' | 'size' | 'filters' | 'text' | 'clipart' | 'qrcode';
interface LeftToolRailProps {
  activeTool: ToolType;
  onToolChange: (tool: ToolType) => void;
}
export function LeftToolRail({
  activeTool,
  onToolChange
}: LeftToolRailProps) {
  const tools = [{
    id: 'cutline',
    icon: Scissors,
    label: 'Cutline'
  }, {
    id: 'quantity',
    icon: Hash,
    label: 'Quantity'
  }, {
    id: 'size',
    icon: Maximize,
    label: 'Size'
  }, {
    id: 'filters',
    icon: Sliders,
    label: 'Filters'
  }, {
    id: 'text',
    icon: Type,
    label: 'Text'
  }, {
    id: 'clipart',
    icon: Image,
    label: 'Clipart'
  }, {
    id: 'qrcode',
    icon: QrCode,
    label: 'QR code'
  }] as const;
  return <div className="w-20 bg-white border-r border-gray-200 flex flex-col items-center py-4 h-full z-20 shadow-sm" data-id="element-98">
      <div className="flex-1 space-y-4 w-full px-2" data-id="element-99">
        {tools.map(tool => {
        const isActive = activeTool === tool.id;
        return <button key={tool.id} onClick={() => onToolChange(tool.id)} className={`
                w-full flex flex-col items-center justify-center py-3 rounded-lg transition-all duration-200 group
                ${isActive ? 'bg-violet-600 text-white' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'}
              `} data-id="element-100">
              <tool.icon size={24} className={`mb-1 ${isActive ? 'text-white' : 'text-gray-500 group-hover:text-gray-900'}`} data-id="element-101" />
              <span className="text-[10px] font-medium" data-id="element-102">{tool.label}</span>
            </button>;
      })}
      </div>

      <button className="text-gray-400 hover:text-gray-600 p-2 mt-auto" data-id="element-103">
        <HelpCircle size={24} data-id="element-104" />
      </button>
    </div>;
}